import { ChangeDetectionStrategy, Component, HostBinding, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-initials',
  templateUrl: 'initials.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InitialsComponent {
  @HostBinding('class')
  public readonly classes = 'btn btn-icon btn-light-primary btn-active-light-primary fw-bolder w-30px h-30px w-md-40px h-md-40px';

  constructor(changeDetectorRef: ChangeDetectorRef) {
    changeDetectorRef.detach();
  }
}
